// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"648":"1f04b232","726":"64065a48","837":"fff7af14","925":"88f89375","956":"0b3cbd3b","962":"09deb1d9","981":"5588df92"}[chunkId] + ".js";
};